import { Route, Routes, Outlet, Navigate } from 'react-router-dom';
import { PageLink, PageTitle } from '../../../_dashboard/layout/core';
import { AgencyListWrapper } from './agencies-list/AgencyList';
import { useIntl } from 'react-intl';

const AgenciesPage = () => {
  const intl = useIntl();

  const agenciesBreadcrumbs: Array<PageLink> = [
    {
      title: intl.formatMessage({ id: 'AGENCY_PAGE.BREADCRUMB' }),
      path: '/apps/agencies-management/agencies',
      isSeparator: false,
      isActive: false,
    },
    { title: '', path: '', isSeparator: true, isActive: false },
  ];

  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='agencies'
          element={
            <>
              <PageTitle breadcrumbs={agenciesBreadcrumbs}>
                {intl.formatMessage({ id: 'AGENCY_PAGE.TITLE' })}
              </PageTitle>
              <AgencyListWrapper />
            </>
          }
        />
      </Route>
      <Route index element={<Navigate to='/apps/agencies-management/agencies' />} />
    </Routes>
  );
};

export default AgenciesPage;
